import React from "react";
import SettingsView from "../features/settings/views/settings-view";

const SettingsPage: React.FC = () => {
    return (
        <div className="w-full max-h-full overflow-y-auto">
            <div className="px-6 py-[80px] max-w-[848px] mx-auto">
                <SettingsView/>
            </div>
        </div>
    );
};

export default SettingsPage;
